<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <loading v-if="! showContent"></loading>
                <h2 class="titulo" v-if="showContent">{{ title }}</h2>
                <div class="estatisticas bloco" v-if="showContent">
                    <div class="visitantes">
                        <i class="fa fa-users" aria-hidden="true"></i>
                        <span>Visitantes</span><br />
                        <strong>{{ item.guests }}</strong>
                    </div>
                    <div class="usuarios_online">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <span>Usuários online</span><br />
                        <strong>{{ item.usersOnline }}</strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { get } from '../../helpers/api';
    import Loading from '../common/Loading.vue';

    export default {
        components: {
            Loading
        },
        props: ['bloco'],
        data() {
            return {
                title: 'Estatísticas',
                item: {
                    usersOnline: '',
                    guests: ''
                },
                showContent: false
            }
        },
        created() {
            if (this.bloco.nome) {
                this.title = this.bloco.nome;
            }
            let self = this;
            get('content/'+this.bloco.id).then(function (response) {
                self.showContent = true;
                self.item.usersOnline = response.data.result.data.usersOnline;
                self.item.guests = response.data.result.data.guests;
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/home/Statistics.vue